document.querySelector('.shadow-bg').addEventListener('click', function (e) {
  document.querySelector('.shadow-bg').classList.remove('active');
  document.querySelector('.modal').classList.remove('active');
});

document.querySelector('.close-popup').addEventListener('click', function (e) {
  document.querySelector('.modal').classList.remove('active');
  document.querySelector('.shadow-bg').classList.remove('active');
});

function submitForm (e) {
  e.preventDefault();
  const api = e.target.action;
  const emailField = document.querySelector('.header-input');
  const email = emailField.value;
  const params = {
    urlUtm: document.location.href,
    email,
    form: 'Книги - 1 форма',
  };

  document.querySelector('.modal').classList.add('active');
  document.querySelector('.shadow-bg').classList.add('active');

  fetch(api, {
    method: 'post',
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json"
    }
  }).then(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'frmEmail' });
    this.reset()
  })
};

document.querySelector('.top-form').addEventListener('submit', submitForm);
